/**
 * ToolsBox Homepage Rendering Engine
 * Dynamically renders tool cards based on ToolsConfig
 */
(function() {
    'use strict';

    // 缓存常用 DOM 元素
    let toolsGrid;
    let categoryStats = {};

    function getCurrentLang() {
        return document.documentElement.lang || 'en';
    }

    function getCategoryColor(category) {
        const colors = {
            'developer': '#F0F7FF',
            'image': '#F0FDF4',
            'utility': '#FFFBEB',
            'security': '#FEF2F2'
        };
        return colors[category] || '#F8FAFC';
    }

    function createToolCard(toolInfo, lang) {
        const url = `/${lang}/${toolInfo.id}/`;
        const categoryBg = getCategoryColor(toolInfo.category);
        
        return `
            <a href="${url}" class="tool-card group bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-100 dark:border-slate-700/50 hover:shadow-md hover:-translate-y-1 transition-all duration-200 flex items-center gap-5" data-category="${toolInfo.category}" style="--category-bg: ${categoryBg};">
                <div class="icon-bg w-12 h-12 rounded-lg flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-200" style="background-color: ${categoryBg};">
                    ${toolInfo.icon}
                </div>
                <div class="flex-1 min-w-0">
                    <h3 class="text-base font-semibold text-slate-900 dark:text-slate-100 truncate">${toolInfo.name}</h3>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 line-clamp-1">${toolInfo.desc}</p>
                </div>
                <div class="text-slate-300 group-hover:text-blue-500 transition-colors">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
                </div>
            </a>
        `;
    }

    function renderTools(filterCategory = 'all') {
        if (!toolsGrid) return;
        
        const lang = getCurrentLang();
        const toolIds = window.ToolsConfig.getAllToolIds();
        let html = '';
        
        // 重置统计
        const counts = {
            developer: 0,
            image: 0,
            utility: 0,
            security: 0
        };

        toolIds.forEach(id => {
            const toolInfo = window.ToolsConfig.getToolInfo(id, lang);
            if (toolInfo) {
                counts[toolInfo.category] = (counts[toolInfo.category] || 0) + 1;
                
                if (filterCategory === 'all' || toolInfo.category === filterCategory) {
                    html += createToolCard(toolInfo, lang);
                }
            }
        });

        toolsGrid.innerHTML = html;

        // 更新分类计数器 (仅在首次加载或初始化时，这里可以优化，但目前先保持逻辑)
        let totalCount = 0;
        Object.keys(counts).forEach(cat => {
            const badge = document.querySelector(`[data-category="${cat}"] .category-count`);
            if (badge) {
                badge.textContent = counts[cat];
            }
            totalCount += counts[cat];
        });

        // 更新 "全部" 计数器
        const allBadge = document.querySelector(`[data-category="all"] .category-count`);
        if (allBadge) {
            allBadge.textContent = totalCount;
        }

        // 更新激活状态样式
        const btns = document.querySelectorAll('.category-btn');
        btns.forEach(btn => {
            if (btn.getAttribute('data-category') === filterCategory) {
                btn.classList.add('bg-slate-100', 'dark:bg-slate-700', 'font-medium');
                btn.classList.remove('text-slate-700', 'dark:text-slate-300');
                btn.classList.add('text-blue-600', 'dark:text-blue-400');
            } else {
                btn.classList.remove('bg-slate-100', 'dark:bg-slate-700', 'font-medium', 'text-blue-600', 'dark:text-blue-400');
                btn.classList.add('text-slate-700', 'dark:text-slate-300');
            }
        });
    }

    function initCategoryFilter() {
        const categoryList = document.getElementById('category-list');
        if (!categoryList) return;

        categoryList.addEventListener('click', (e) => {
            const btn = e.target.closest('.category-btn');
            if (!btn) return;

            const category = btn.getAttribute('data-category');
            renderTools(category);
            
            // 移动端点击后可以滚动到工具区（可选）
            if (window.innerWidth < 1024) {
                const grid = document.getElementById('tools-grid');
                if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    // Auto-load ToolsConfig if not present
    function ensureToolsConfig() {
        return new Promise(function(resolve) {
            if (window.ToolsConfig && typeof window.ToolsConfig.getAllToolIds === 'function') {
                resolve();
                return;
            }
            
            // Check if script already exists
            if (document.querySelector('script[src*="tools-config"]')) {
                var checkInterval = setInterval(function() {
                    if (window.ToolsConfig && typeof window.ToolsConfig.getAllToolIds === 'function') {
                        clearInterval(checkInterval);
                        resolve();
                    }
                }, 100);
                return;
            }
            
            // Load dynamically
            var script = document.createElement('script');
            script.src = '/shared/js/tools-config.js';
            script.onload = function() {
                resolve();
            };
            script.onerror = function() {
                console.warn('Failed to load ToolsConfig');
                resolve();
            };
            document.head.appendChild(script);
        });
    }

    function init() {
        ensureToolsConfig().then(function() {
            toolsGrid = document.getElementById('tools-grid');
            if (toolsGrid) {
                renderTools();
                initCategoryFilter();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
